import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function RequireAuth({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-sm text-neutral-500">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length > 0 && user.role !== "super_admin" && !roles.includes(user.role)) {
    return (
      <div className="p-8">
        <div className="text-lg font-semibold">Akses Ditolak</div>
        <div className="text-sm text-neutral-600">Peran Anda tidak memiliki hak untuk halaman ini.</div>
      </div>
    );
  }
  return children;
}
